import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbPair } from '../../utils/seoUtils'
import './President.css'

function President() {
  const { t, i18n } = useTranslation()
  const isRussian = i18n.language === 'ru'
  const isJapanese = i18n.language === 'ja'

  const breadcrumbItems = useMemo(
    () => seoBreadcrumbPair(t('common.home'), t('common.president'), 'president'),
    [t]
  )

  return (
    <div className="president-page">
      <SEO 
        title={`${t('president.name', 'Mikhail Sergeevich Makhnev')} - ${t('common.president', 'President')}`}
        description={t('president.description', 'Learn about the President of SUMA International - Mikhail Sergeevich Makhnev')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <div className="president-hero">
          <div className="president-hero-content">
            <div className="president-photo-container">
              <img 
                src="/images/persons/Makhnev_Mikhail_Sergeevich.jpg" 
                alt={t('president.name', 'Mikhail Sergeevich Makhnev')}
                className="president-photo"
              />
            </div>
            <div className="president-hero-text">
              <p className="president-subtitle">{t('common.president', 'President')}</p>
              <h1>{t('president.name', 'Mikhail Sergeevich Makhnev')}</h1>
              <p className="president-position">{t('president.position', 'President of SUMA International')}</p>
              <p className="president-position-secondary">{t('president.positionSecondary', 'Member of the Presidium of the Supreme Council')}</p>
              <p className="president-rank">{t('president.rank', '5th Dan Ju-Jutsu')}</p>
              <p className="president-intro">
                {t('president.intro', 'Mikhail Sergeevich Makhnev is the President of SUMA International, an experienced master of Ju-Jutsu with the rank of 5th Dan. He leads the organization in its mission to unite martial arts schools and federations, promote excellence in training, and preserve traditional values.')}
              </p>
            </div>
          </div>
        </div>

        <div className="president-content">
          <section className="president-section">
            <h2>{t('president.biography', 'Biography')}</h2>
            <p>
              {t('president.biographyText', 'Mikhail Sergeevich Makhnev is an experienced master of Ju-Jutsu, holding the rank of 5th Dan. He has dedicated many years to the practice and teaching of martial arts, contributing to the development of Ju-Jutsu in Russia and beyond.')}
            </p>
            <p>
              {t('president.biographyText2', 'As President of SUMA International, Mikhail Sergeevich leads the organization in its mission to unite martial arts schools and federations, promote high standards in training, and preserve traditional values while fostering cooperation among practitioners.')}
            </p>
          </section>

          <section className="president-section">
            <h2>{t('president.activities', 'Activities')}</h2>
            <p>
              {t('president.activitiesText', 'Mikhail Sergeevich actively participates in the development of SUMA International, organizing events, seminars, and training sessions. He works to strengthen ties between martial arts schools and promote the growth of the martial arts community.')}
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default President
